// RptDisplayDialog.js
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {string} rpt state variable, contents of an rpt file.
 * @returns UI for displaying the contents of a swmm .rpt file.
 */
export default function RptDisplayDialog({rpt}) {
  return(
    <>
      <div style={{ backgroundColor:'black'}} >
        <label>Modeling Report</label>
      </div>
      <div style={{position: 'absolute', height: 'calc(100% - 100px)', width: 'calc(100% - 30px)', display: 'inline', overflow: 'scroll', background: 'radial-gradient(circle at 3% 25%,#002853 0,#040c18 100%,violet 0)', color: 'white'}}>
        <pre className="rpt-contents">{rpt}</pre>
      </div>
    </>
  )
}

